"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-pietro-a-maida": {
    "59fc3422": [{
      "hkey": "a9330504",
      "slug": "san-pietro-a-maida",
      "name": "San Pietro a Maida",
      "primary": true,
      "skipSearch": false
    }],
    "samboni": [{
      "hkey": "a9330504",
      "slug": "san-pietro-a-maida",
      "name": "San Pietro a Maida",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "62c5df9d": [{
      "hkey": "a9330504",
      "slug": "san-pietro-a-maida",
      "name": "San Pietro a Maida",
      "primary": true,
      "skipSearch": false
    }],
    "san-pietro-scalo": [{
      "hkey": "a9330504",
      "slug": "san-pietro-a-maida",
      "name": "San Pietro a Maida",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a8d2ef8b": [{
      "hkey": "a9330504",
      "slug": "san-pietro-a-maida",
      "name": "San Pietro a Maida",
      "primary": true,
      "skipSearch": false
    }],
    "serre": [{
      "hkey": "a9330504",
      "slug": "san-pietro-a-maida",
      "name": "San Pietro a Maida",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;